"use strict";
import Vue from 'vue';
import axios from "axios";
import Config from './http.config';

let config = {
    baseURL: Config.url,
    timeout: 10 * 1000, // 请求超时时间
    withCredentials: false, // 跨域验证
    validateStatus: (status) => { // 状态码校验 
        return status >= 200 && status < 300; // 默认200及以上300以下
    },
};

const _axios = axios.create(config);

// 添加请求拦截器
_axios.interceptors.request.use(
    (config) => {
        // console.log("请求前响应", config);
        // console.log('检测语言缓存', localStorage.getItem('LANG') )
        config.headers.lang = localStorage.getItem('LANG') || 'cn';
        return config;
    },
    (error) => {
        console.log("请求后错误响应", config);
        return Promise.reject(error);
    }
);

// 添加响应拦截器，请求后
_axios.interceptors.response.use(
    (response) => {
        // console.log("请求后响应", response);
        return response.data;

    },
    (error) => {
        // console.log("请求后错误响应", error);
        return Promise.reject(error);
    }
);

// 挂载到Vue实例
Plugin.install = function(Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};




Vue.use(Plugin);


export default _axios;